import React, { useEffect } from 'react';

import { Container, Pagination } from '@mui/material';
import { observer } from 'mobx-react';

import classes from './NgzScholasticCustomerList.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { ScholasticCustomerPageTitle } from './ScholasticCustomerPageTitle/ScholasticCustomerPageTitle';
import { TitleRow } from './TitleRow/TitleRow';
import { scholasticCustomersListStore } from '../../stores/ScholasticCustomersListStore';
import { FilterRow } from './FilterRow/FilterRow';
import { CustomerRow } from './CustomerRow/CustomerRow';
import { useCustomFilter } from '../../../shared/features/custom-filter';
import { EmptyList } from '../../../shared/components/ui-components';

type NgzScholasticCustomerListProps = {
  listTitle: string;
};

const NgzScholasticCustomerList = observer(
  ({ listTitle }: NgzScholasticCustomerListProps) => {
    const { customerList, getCustomerListInitData, filterMethod } =
      scholasticCustomersListStore;
    const { isShowPagination, isShowPlaceholder, isSearchUsed, getPaginationProps } =
      filterMethod;

    useCustomFilter('scholastic');

    useEffect(() => {
      getCustomerListInitData();
    }, []);

    const paginationProps = getPaginationProps();

    return (
      <Container>
        <ScholasticCustomerPageTitle title={listTitle} />
        <div className={classes.scholasticTable}>
          <TitleRow />
          <FilterRow />
          {customerList.map((userInfo) => (
            <CustomerRow userInfo={userInfo} key={userInfo.id} />
          ))}
        </div>
        {isShowPagination && <Pagination {...paginationProps} />}
        <EmptyList
          show={isShowPlaceholder}
          isSearch={isSearchUsed}
          description="There are no customers"
        />
      </Container>
    );
  },
);

angularizeWithProviders(NgzScholasticCustomerList, 'ngzScholasticCustomerList', {
  listTitle: '<',
});

export { NgzScholasticCustomerList };
